// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__3qedD","header":"styles_header__3zdvE","date":"styles_date__Ahsxm","submit":"styles_submit__lCZs_"};